"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tree = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _useStyles2 = _interopRequireDefault(require("./useStyles"));

var _Hocs = require("../../Hocs");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Tree = function Tree(_ref) {
  var lists = _ref.lists;

  var _useStyles = (0, _useStyles2["default"])(),
      primary = _useStyles.primary,
      secondary = _useStyles.secondary,
      wrapper = _useStyles.wrapper,
      btn = _useStyles.btn;

  return /*#__PURE__*/_react["default"].createElement(_core.List, null, lists.map(function (list, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      key: list.title + i,
      className: wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      disableTypography: true,
      className: secondary,
      primary: list.title
    }), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      disableTypography: true,
      className: primary,
      primary: list.body
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      "aria-label": "link",
      className: btn
    }, /*#__PURE__*/_react["default"].createElement(_icons.ChevronRight, {
      onClick: list.onClick
    })))));
  }));
};

exports.Tree = Tree;
Tree.propTypes = {
  lists: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    body: _propTypes["default"].string.isRequired,
    onClick: _propTypes["default"].func.isRequired
  })).isRequired
};

var _default = (0, _Hocs.renderListSafely)(Tree);

exports["default"] = _default;